import { render, staticRenderFns } from "./NotificationNewBtn.vue?vue&type=template&id=4af92146&lang=true&"
import script from "./NotificationNewBtn.vue?vue&type=script&lang=js&"
export * from "./NotificationNewBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports